/**
 * Stub for `react-pdf/dist/esm/entry.webpack`, aliased in from config/webpack.config.js — KWA-28822.
 *
 * Why this exists: @kyc-ui/react depends on react-pdf, and exactly one of its components uses it
 * (src/components/documentPreviewDialog/DocumentPreviewDialog.tsx). The package ships as a single
 * ESM bundle with no `sideEffects: false`, so webpack cannot drop the unused export and pdfjs-dist
 * came along with it: a 345 kB `pdf.worker` file emitted next to index.html, plus four
 * dynamic-execution sites in the app bundle —
 *
 *   new Function("c","size",…)                              the compiled-glyph path
 *   new Function("src","srcOffset","dest","destOffset",…)   the PostScript function compiler
 *   new Function("")                                        the IsEvalSupported probe
 *   eval("require")(workerSrc)                              the fake-worker fallback
 *
 * The first two are live code in pdfjs, not dead branches, so keeping them would have meant
 * allowlisting real eval sites in the CSP gate on the argument that this app never renders a PDF.
 * It does not: the Billing Portal renders one screen (src/App.tsx:11) and imports no dialog
 * component from @kyc-ui/react. Removing the engine makes `script-src 'self'` provable instead of
 * argued, and drops ~350 kB from the bundle.
 *
 * The exports below are the real module's shape, so nothing changes for code that only imports
 * @kyc-ui/react. They throw when RENDERED rather than when imported, because this module IS
 * evaluated on every page load — @kyc-ui/react's barrel pulls it in whether or not the dialog is
 * used. A module-level throw would take the whole app down.
 *
 * If the Billing Portal ever needs DocumentPreviewDialog, delete the alias rather than the throw,
 * and then reckon with pdfjs's eval sites in csp.config.ts. scripts/check-csp-bundle.js will fail
 * the build the moment pdfjs returns, so this cannot be undone quietly.
 */

var MESSAGE =
  'react-pdf is stubbed out in this app (config/stubs/reactPdfEntry.js, KWA-28822): pdfjs-dist ' +
  "needs script-src 'unsafe-eval', and the Billing Portal renders no PDF. To use " +
  '@kyc-ui/react\'s DocumentPreviewDialog here, remove the react-pdf alias in ' +
  'config/webpack.config.js and widen csp.config.ts to match.'

function refuse() {
  throw new Error(MESSAGE)
}

// `pdfjs` is a namespace object on the real module. Only `GlobalWorkerOptions.workerSrc` is
// touched by the entry point we are replacing, so a plain object is enough; anything else that
// reads off it gets `undefined` rather than a confusing partial implementation.
export var pdfjs = { GlobalWorkerOptions: {} }

export var Document = refuse
export var Outline = refuse
export var Page = refuse
